import React, { useState, useRef, useEffect, ReactNode } from "react";
import ReactDOM from "react-dom";
import "./Tooltip.scss";

interface TooltipProps {
  children: ReactNode;
  text: string;
  position?: "top" | "bottom" | "left" | "right";
};

const Tooltip: React.FC<TooltipProps> = ({ children, text, position = "right" }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (visible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const offset = 8;

      const positions = {
        top: {
          top: rect.top - offset,
          left: rect.left + rect.width / 2,
        },
        bottom: {
          top: rect.bottom + offset,
          left: rect.left + rect.width / 2,
        },
        left: {
          top: rect.top + rect.height / 2,
          left: rect.left - offset,
        },
        right: {
          top: rect.top + rect.height / 2,
          left: rect.right + offset,
        },
      };

      setCoords(positions[position]);
    }
  }, [visible, position]);

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="tooltip-trigger"
      >
        {children}
      </div>

      {visible &&
        ReactDOM.createPortal(
          <div
            className={`tooltip-box portal ${position}`}
            style={{
              position: "fixed",
              top: coords.top,
              left: coords.left,
              transform:
                position === "top" || position === "bottom"
                  ? "translateX(-50%)"
                  : "translateY(-50%)",
            }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
};

export default Tooltip;